import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const copy: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M13.25-9q.31 0 .531.219A.74.74 0 0 1 14-8.25v9.5a.74.74 0 0 1-.219.531.74.74 0 0 1-.531.219h-7.5a.72.72 0 0 1-.531-.219A.72.72 0 0 1 5 1.25V-1H.75a.7.7 0 0 1-.531-.219A.7.7 0 0 1 0-1.75V-7q-.001-.311.156-.687.153-.374.375-.594L3.72-11.47q.218-.217.594-.375c.25-.101.476-.156.687-.156h3.25q.31 0 .531.219A.74.74 0 0 1 9-11.25v2.563C9.352-8.895 9.688-9 10-9zM9-7.344 6.672-5H9Zm-5-3L1.672-8H4zM5.531-5.28 8-7.75V-11H5v3.25q0 .316-.219.531A.72.72 0 0 1 4.25-7H1v5h4v-2q-.002-.311.156-.687.153-.373.375-.594M13 1v-9h-3v3.25q0 .316-.219.531A.72.72 0 0 1 9.25-4H6v5zm0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 12)"
    />
  ),
  svgProps: {
    height: "14",
    width: "14",
  }
};